"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var lodash_1 = require("lodash");
var defaults_1 = require("./defaults");
var Highcharts = __importStar(require("highcharts"));
var accessibility_1 = __importDefault(require("highcharts/modules/accessibility"));
var pattern_fill_1 = __importDefault(require("highcharts/modules/pattern-fill"));
var highcharts_react_official_1 = __importDefault(require("highcharts-react-official"));
// Initialize plugins
accessibility_1.default(Highcharts);
pattern_fill_1.default(Highcharts);
var DataChart = /** @class */ (function (_super) {
    __extends(DataChart, _super);
    function DataChart(props) {
        return _super.call(this, props) || this;
    }
    DataChart.getAxisRange = function (seriesData) {
        var errorMessage = 'DataChart > getAxisRange > data point property is not a number. Data point must be a [number, number] or {x:number, y:number}. data point: ';
        var xValues = [].concat.apply([], __spread(seriesData.map(function (obj) {
            return obj.data.map(function (point) {
                if (typeof point[0] !== 'number' && typeof point['x'] !== 'number')
                    throw errorMessage + JSON.stringify(point);
                return typeof point[0] !== 'number' ? point['x'] : point[0];
            });
        })));
        var yValues = [].concat.apply([], __spread(seriesData.map(function (obj) {
            return obj.data.map(function (point) {
                if (typeof point[1] !== 'number' && typeof point['y'] !== 'number')
                    throw errorMessage + JSON.stringify(point);
                return typeof point[1] !== 'number' ? point['y'] : point[1];
            });
        })));
        return {
            xMin: Math.min.apply(Math, __spread(xValues)),
            yMin: Math.min.apply(Math, __spread(yValues)),
            xMax: Math.max.apply(Math, __spread(xValues)),
            yMax: Math.max.apply(Math, __spread(yValues)),
        };
    };
    DataChart.getAbreviatedMoneyFormat = function (baseCurrencySymbol, value) {
        return (baseCurrencySymbol +
            (Math.abs(Number(value)) >= 1.0e9
                ? Math.abs(Number(value)) / 1.0e9 + 'B'
                : Math.abs(Number(value)) >= 1.0e6
                    ? Math.abs(Number(value)) / 1.0e6 + 'M'
                    : Math.abs(Number(value)) >= 1.0e3
                        ? Math.abs(Number(value)) / 1.0e3 + 'K'
                        : Math.abs(Number(value))));
    };
    DataChart.prototype.render = function () {
        var combinedConfig = {};
        var series = this.props.options.series;
        var chartType = series && series[0].type; //assumes all objects in series are same chart type
        var middlewareOptions = chartType === 'area'
            ? defaults_1.areaChartDefaults
            : chartType === 'column'
                ? defaults_1.columnChartDefaults
                : chartType === 'line'
                    ? defaults_1.lineChartDefaults
                    : chartType === 'pie'
                        ? defaults_1.pieChartDefaults
                        : [];
        lodash_1.merge(combinedConfig, defaults_1.commonChartDefaults(this.props.label), middlewareOptions, this.props.options);
        return react_1.default.createElement(highcharts_react_official_1.default, { highcharts: Highcharts, options: combinedConfig });
    };
    return DataChart;
}(react_1.default.Component));
exports.DataChart = DataChart;
